import css from 'styled-jsx/css';
import { colors } from '../../../themes';

export default css`
  .notFoundMessage {
    padding: 20px;
    text-align: left;
  }

  h1 {
    color: ${colors.grayDeep};
    font-size: 1.4em; /* 18/16 */
    font-weight: bold;
    line-height: 1.25;
    margin-bottom: 10px;
  }

  h2 {
    font-size: 0.9375em; /* 15/16 */
    line-height: 1.5;
  }

  hr {
    border-radius: 3px;
    margin: 25px 0 5px;
    border: none;
    border-top: 2px solid #f2f2f2;
  }

  :global(.rtl) .notFoundMessage {
    text-align: right;
  }

  :global(.suggestionsPlaceholder) {
    display: block;
    width: 100%;
    height: 15rem;
  }
`;



// WEBPACK FOOTER //
// ./app/Error/components/Error404/styles.js